import React from 'react';
import { MapPin, Phone, Clock, AlertCircle } from 'lucide-react';
export function ServiceArea() {
  const locations = [{
    name: 'Howell Auto Glass Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    desc: 'Main showroom and auto glass service center',
    featured: true
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    desc: ''
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    desc: ''
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-1053" data-mp="3o4l4jp7w16yn">
      <div className="max-w-7xl mx-auto" data-id="element-1054" data-mp="1pp8gv11ag2rf">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-1055" data-mp="1pq9r53ahcl83">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-normal leading-tight" data-id="element-1056" data-mp="1tpab4p4p1two">
            <span className="text-emergencyBrand-red" data-id="element-1057" data-mp="1cb069rqqb9fw">
              Emergency Auto Glass
            </span>{' '}
            Near Howell, Ann Arbor, Novi &amp; Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600 mb-6" data-id="element-1058" data-mp="12kfbygi38r2s">
            Kosin's Glass serves drivers across Southeast Michigan, including
            Howell, Ann Arbor, Novi, Brighton, Fenton, Hartland, Fowlerville,
            Northville, Lansing, East Lansing, Grand Blanc, Webberville,
            Williamston, Livonia, Milford, Pinckney, Whitmore Lake, Wixom and
            nearby communities.
          </p>
          <div className="inline-flex items-start sm:items-center gap-2 bg-white text-slate-700 px-4 py-2.5 rounded-lg border border-slate-200 font-medium text-sm shadow-sm text-left" data-id="element-1059" data-mp="1l8kb1ansvnv9">
            <AlertCircle className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5 sm:mt-0" data-id="element-1060" data-mp="9vrku4anr7hb" />
            <span data-id="element-1061" data-mp="4uu1vphtq9er">
              For urgent auto glass help, call first to confirm today's
              availability and the safest next step.
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-1062" data-mp="2x3p88t5j0acp">
          {locations.map((loc, i) => <div key={i} className={`bg-white rounded-lg p-6 border shadow-sm flex flex-col h-full ${loc.featured ? 'border-emergencyBrand-red/40 ring-1 ring-emergencyBrand-red/20' : 'border-slate-200'}`} data-id="element-1063" data-mp="2j2uz28anm5cz" data-mpi={i}>
              {loc.featured && <div className="inline-block bg-emergencyBrand-red text-white px-2.5 py-1 text-xs font-bold uppercase tracking-normal rounded mb-3 w-fit" data-id="element-1064" data-mp="2e4tf7l5em20g">
                  Main Location
                </div>}
              <h3 className="text-lg font-bold text-slate-900 mb-4" data-id="element-1065" data-mp="25crjg06a59wi">
                {loc.name}
              </h3>
              <div className="space-y-3 flex-grow" data-id="element-1066" data-mp="1qfqzwjy8sl94">
                <div className="flex items-start gap-2.5" data-id="element-1067" data-mp="1vebrxw3cbymh">
                  <MapPin className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5" data-id="element-1068" data-mp="1vfwn9nxhblle" />
                  <span className="text-slate-600" data-id="element-1069" data-mp="1bucvltjde7i8">{loc.address}</span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-1070" data-mp="17shuoq5cpw4z">
                  <Phone className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5" data-id="element-1071" data-mp="1lqpzfk8mq1qp" />
                  <a href={`tel:${loc.phone}`} className="text-slate-900 font-bold hover:text-emergencyBrand-red transition-colors" data-id="element-1072" data-mp="1gqtwzpfkyid9">
                    {loc.phone}
                  </a>
                </div>
                {loc.desc && <p className="text-sm text-slate-500 mt-4 pt-4 border-t border-slate-100" data-id="element-1073" data-mp="24hh448ho93yr">
                    {loc.desc}
                  </p>}
              </div>
            </div>)}
        </div>
        <div className="bg-white rounded-lg p-6 sm:p-8 text-center max-w-2xl mx-auto border border-slate-200 shadow-sm" data-id="element-1074" data-mp="2eg6m019kiof0">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-1075" data-mp="29hvgg2qb302l">
            <Clock className="w-5 h-5 text-emergencyBrand-red" data-id="element-1076" data-mp="6sc268r06hpm" />
            <h3 className="text-lg font-bold text-slate-900" data-id="element-1077" data-mp="bs6py3fher6g">Hours</h3>
          </div>
          <div className="space-y-1.5 text-slate-600" data-id="element-1078" data-mp="bq3u32rne3tt">
            <p data-id="element-1079" data-mp="gkhph56b8ayh">
              <span className="font-semibold text-slate-900" data-id="element-1080" data-mp="gjyi2iead4yp">
                Monday–Friday:
              </span>{' '}
              8:00 a.m. to 5:00 p.m.
            </p>
            <p data-id="element-1081" data-mp="3k0ykp3pf4nf2">
              <span className="font-semibold text-slate-900" data-id="element-1082" data-mp="3k1gfrx0cgvle">Saturday:</span>{' '}
              9:00 a.m. to 3:00 p.m.
            </p>
            <p data-id="element-1083" data-mp="3p0t9n1pmv2xh">
              <span className="font-semibold text-slate-900" data-id="element-1084" data-mp="3tycoa2q8thpy">Sunday:</span>{' '}
              Closed
            </p>
          </div>
        </div>
      </div>
    </section>;
}